import React, { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import styles from './SpecialInstruction.module.scss';

interface ISpecialInstructionProps {
	externalStyle: CSSProperties;
	label?: string;
	placeholder?: string;
	text?: string;
	handleChange: (value: string) => void;
}

const MAX_TEXT_ALLOWED = 33;

const SpecialInstruction: React.FC<ISpecialInstructionProps> = ({
	externalStyle,
	label,
	placeholder,
	text,
	handleChange,
	...props
}: ISpecialInstructionProps) => {
	const intl = useIntl();

	return (
		<>
			<section className={styles.specialInstruction} {...props} style={externalStyle} id="specialInstruction">
				<div>
					<div className={styles.specialInstructionContainer}>
						<div className={styles.labelGroup}>
							<label className={styles.instructionLabel}>{label}</label>
							<label htmlFor="specialInstructions" className={styles.instructionLabel2}>
								{intl.formatMessage({ id: 'component:specialInstruction:hint:text' })}
							</label>
						</div>
						<div className={styles.modifierOptional}>{intl.formatMessage({ id: 'component:modifier:optional:label' })}</div>
					</div>
					<input
						className={styles.instructionTextarea}
						placeholder={placeholder}
						maxLength={MAX_TEXT_ALLOWED}
						onChange={(e) => handleChange(e.target.value)}
						value={text}
					/>
				</div>
			</section>
		</>
	);
};

export default SpecialInstruction;
